module.exports = __webpack_public_path__ + "media/src/assets/Images/AddPDF-ccc72fcd2e6272636a622a96260ede10.svg";